import { isWoman, vocative } from 'czech-vocative';

export const capitalizeFirstLetter = (name: string): string => {
  if (!name) {
    return name;
  }

  const isFirstCharLetter = /^[\p{L}]/u.test(name);
  if (isFirstCharLetter) {
    return name.charAt(0).toLocaleUpperCase('cs-CZ') + name.slice(1).toLocaleLowerCase('cs-CZ');
  }

  return name;
};

export const getGreeting = (userName?: string) => {
  const trimmedName = userName?.trim();
  if (!trimmedName) {
    return '';
  }

  const title = isWoman(trimmedName) ? 'paní' : 'pane';
  const name = capitalizeFirstLetter(vocative(trimmedName));

  return `${title} ${name}, `;
};
